import { DebounceExpression } from '@trackback/widgets';
import { createNamedExpressionResolver } from '../types';

export const debounceResolver =
  createNamedExpressionResolver<DebounceExpression>(
    'debounce',
    (parser, options, onDataChange, [expr, timeMs]) => {
      let timer: number;

      const unsubscribe = parser.parseWithCallback(
        expr,
        {
          next: nextValue => {
            if (timer) {
              clearTimeout(timer);
            }
            timer = setTimeout(() => {
              onDataChange.next(nextValue);
              timer = null;
            }, timeMs);
          },
          error: onDataChange.error,
        },
        options
      );

      return () => {
        if (timer) {
          clearTimeout(timer);
        }
        if (unsubscribe) {
          unsubscribe();
        }
      };
    }
  );
